import { TweenMax, TimelineMax } from 'gsap';
import {windowSize} from './windowSize';
import {state} from './state';
import {whalehandle} from './whalehandle';
import {inview} from './inviewhandle';

let contentRoot=document.getElementById("wrap");
let freeScrollArea=$('.js-normalScroll');
let sceneSet = {
  duration:1.1,
  duration2:0.7,
  ease:"Expo.easeOut", //  Power4.easeInOut
  ease2:"Expo.easeIn",
  isWhaleFirst:true,
  menuTransTl: new TimelineMax(),
  anchorTargetSet:[{
    "2": $('.health'),
    "3": $('.recipe'),
    "4": $('.product'),
    "5": $('.whaleMap')
  }],
};

export const wheel={
  mousewheelevent: 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll',
  mouseWheelEvt: () => {
    try{
      document.addEventListener(wheel.mousewheelevent, wheel.onWheel, { passive: false });
    }
    catch(e){
      document.attachEvent("onmousewheel", wheel.onWheel); //for legacy IE
    }
  },
  noMouseWheelEvt:() =>{
    try{
      document.removeEventListener(wheel.mousewheelevent, wheel.onWheel, { passive: false });
    }
    catch(e){
      document.detachEvent("onmousewheel", wheel.onWheel);
    }
  },
  onWheel: (e) => {

    if (!e) { e=window.event; }

    let delta = e.deltaY ? -(e.deltaY) : e.wheelDelta ? e.wheelDelta : -(e.detail);
    if (delta <= -1){
      e.preventDefault();
      if (state.currentID<2){
        wheel.noMouseWheelEvt();
        state.isSceneTrans=true;
        state.currentID=Math.min(state.currentID+1, 2);
        wheel.next();
      }
    }
    else if (delta >= 1){
      e.preventDefault();
      if (state.freeScrollPos==0){
        wheel.noMouseWheelEvt();
        state.isSceneTrans=true;
        state.currentID=Math.max(state.currentID-1, 0);
        wheel.prev();
      }
    }
    
    if (state.currentID==2 && state.isMenu==true) {
      let freeScrollAreaHeight=freeScrollArea.innerHeight();
      state.freeScrollPos=state.freeScrollPos+delta;
      state.freeScrollPos=Math.min(state.freeScrollPos,0);
      state.freeScrollPos=Math.max(state.freeScrollPos,-freeScrollAreaHeight+windowSize.clientSize().H);
      if (state.freeScrollPos >= (-freeScrollAreaHeight+windowSize.clientSize().H)){
        TweenMax.to(freeScrollArea, .2, {y:state.freeScrollPos});
        inview.inview();
      }
    }
  },
  next: () => {
    TweenMax.to(
      contentRoot,
      sceneSet.duration,
      {
        ease:sceneSet.ease,
        y:-(windowSize.clientSize().H*state.currentID),
        onComplete:()=>{
          wheel.firstWhale();
          setTimeout(()=>{
            wheel.mouseWheelEvt();
            // if (state.currentID==1){
            //   whalehandle.mouseWheelEvt();
            // }
            // else {
            //   wheel.mouseWheelEvt();
            // }
            state.isSceneTrans=false;
          },600);
          if (state.currentID==2){
            inview.stackItemsPosition();
            inview.inview();
          }
        }
      }
    );
  },
  prev: () => {
    TweenMax.to(
      contentRoot,
      sceneSet.duration,
      {
        ease:sceneSet.ease,
        y:(state.currentID==1) ? -windowSize.clientSize().H : 0,
        onComplete:()=>{
          wheel.firstWhale();
          setTimeout(()=>{
            wheel.mouseWheelEvt();
            // if (state.currentID==1){
            //   whalehandle.mouseWheelEvt();
            // }
            // else {
            //   wheel.mouseWheelEvt();
            // }
            state.isSceneTrans=false;
          },600);
        }
      }
    );
  },
  onClickToNextScene: (id) => { // id =>1,2,3,4
    let freeScrollAreaValue=0;
    if(state.currentID==0 || state.currentID==1){ // 今 mv or whaleにいる
      let adjustVal=0;
      if(state.currentID==0){
        adjustVal=windowSize.clientSize().H*2;
      }
      else if (state.currentID==1){
        adjustVal=windowSize.clientSize().H;
      }

      if(id==1){
        freeScrollAreaValue=0;
      }
      else if(id==2){
        freeScrollAreaValue=0;
      }
      else if(id>2){
        freeScrollAreaValue=(sceneSet.anchorTargetSet[0][id].offset().top) - adjustVal;
      }

      state.freeScrollPos=-freeScrollAreaValue;
      
      //  id==1は鯨
      if(id==1){
        state.currentID=id;
        TweenMax.to(
          contentRoot,
          sceneSet.duration,
          {
            ease:sceneSet.ease,
            y:-(windowSize.clientSize().H*state.currentID),
            onComplete:()=>{
              wheel.firstWhale();
              setTimeout(()=>{
                wheel.mouseWheelEvt();
                // if (state.currentID==1){
                //   whalehandle.mouseWheelEvt();
                // }
                // else {
                //   wheel.mouseWheelEvt();
                // }
                // state.freeScrollPos=0;
                state.isSceneTrans=false;
                state.isMenu=true;
              },500);
            }
          }
        )
      }
      // 「鯨と健康」、「鯨レシピ」、「おすすけ商品」
      if(id>1){
        state.currentID=2;
        sceneSet.menuTransTl.to(
          contentRoot,
          (id==2) ? sceneSet.duration : sceneSet.duration2,
          {
            ease:(id==2) ? sceneSet.ease : sceneSet.ease2,
            y:-(windowSize.clientSize().H*state.currentID),
            onComplete:()=>{
              inview.stackItemsPosition();
              inview.inview();
            }
          }
        )
        .to(
          freeScrollArea,
          sceneSet.duration,
          {
            ease:sceneSet.ease,
            y:state.freeScrollPos,
            onComplete:()=>{
              setTimeout(()=>{
                wheel.mouseWheelEvt();
                // if (state.currentID==1){
                //   whalehandle.mouseWheelEvt();
                // }
                // else {
                //   wheel.mouseWheelEvt();
                // }
                inview.inview();
                // state.backToFixedArea=false;
                state.isSceneTrans=false;
                state.isMenu=true;
              },500);
            }
          }
        )
      }
    }
    else if(state.currentID==2){
      if(id<=1){
        state.currentID=1;
        state.freeScrollPos=0;
        sceneSet.menuTransTl.to(
          freeScrollArea,
          // sceneSet.duration,
          sceneSet.duration2,
          {
            // ease:sceneSet.ease,
            ease:sceneSet.ease2,
            y:state.freeScrollPos,
          }
        )
        .to(
          contentRoot,
          sceneSet.duration,
          {
            ease:sceneSet.ease,
            y:-(windowSize.clientSize().H*state.currentID),
            onComplete:()=>{
              wheel.firstWhale();
              setTimeout(()=>{
                wheel.mouseWheelEvt();
                // if (state.currentID==1){
                //   whalehandle.mouseWheelEvt();
                // }
                // else {
                //   wheel.mouseWheelEvt();
                // }
                inview.inview();
                state.freeScrollPos=0;
                // state.backToFixedArea=true;
                state.isSceneTrans=false;
                state.isMenu=true;
              },500);
            }
          }
        )
      }
      else{
        freeScrollAreaValue=sceneSet.anchorTargetSet[0][id].offset().top;
        state.freeScrollPos=state.freeScrollPos-freeScrollAreaValue;
        TweenMax.to(
          freeScrollArea,
          sceneSet.duration,
          {
            ease:sceneSet.ease,
            y:state.freeScrollPos,
            onComplete:()=>{
              setTimeout(()=>{
                wheel.mouseWheelEvt();
                // if (state.currentID==1){
                //   whalehandle.mouseWheelEvt();
                // }
                // else {
                //   wheel.mouseWheelEvt();
                // }
                // state.backToFixedArea=false;
                state.isSceneTrans=false;
                state.isMenu=true;
              },500);
            }
          }
        )
      }
    }
  },
  firstWhale:()=>{
    if(sceneSet.isWhaleFirst==true && state.currentID==1){
      sceneSet.isWhaleFirst=false;
      $(".w-whale01").addClass("is-active");
    }
  },
  resetSceneSize: ()=> {
    TweenMax.set(contentRoot,{y:-windowSize.clientSize().H*state.currentID});
  },
};